"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXTOCItem = exports.HTMLTOCItem = exports.DOCXTOC = exports.HTMLTOC = exports.HTMLTOCCSS = void 0;
const react_1 = __importDefault(require("react"));
const std = __importStar(require("../../law/std"));
const util_1 = require("../../util");
const html_1 = require("../common/html");
const sentenceChildrenRun_1 = require("./sentenceChildrenRun");
const component_1 = require("../common/docx/component");
const tags_1 = require("../common/docx/tags");
const inline_1 = require("../../node/cst/inline");
const common_1 = require("../common");
exports.HTMLTOCCSS = `
.toc {
    clear: both;
}

.toc-label {
    clear: both;
    font-weight: bold;
}

`;
exports.HTMLTOC = (0, html_1.wrapHTMLComponent)("HTMLTOC", ((props) => {
    const { el, htmlOptions, indent } = props;
    const blocks = [];
    const TOCLabel = el.children.find(std.isTOCLabel);
    if (TOCLabel) {
        blocks.push((react_1.default.createElement("div", { className: `toc-label indent-${indent}`, ...(0, html_1.elProps)(TOCLabel, htmlOptions) },
            react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: TOCLabel.children, htmlOptions }))));
    }
    const bodyBlocks = [];
    for (const child of el.children) {
        if (std.isTOCLabel(child)) {
            continue;
        }
        else if (std.isTOCItem(child)) {
            bodyBlocks.push(react_1.default.createElement(exports.HTMLTOCItem, { el: child, indent: indent + 1, htmlOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    if (bodyBlocks.length > 0) {
        blocks.push((react_1.default.createElement("div", { className: "toc-body" }, (0, common_1.withKey)(bodyBlocks))));
    }
    return (react_1.default.createElement("div", { className: "toc", ...(0, html_1.elProps)(el, htmlOptions) }, (0, common_1.withKey)(blocks)));
}));
exports.DOCXTOC = (0, component_1.wrapDOCXComponent)("DOCXTOC", ((props) => {
    const { el, docxOptions, indent } = props;
    const blocks = [];
    const TOCLabel = el.children.find(std.isTOCLabel);
    if (TOCLabel) {
        blocks.push((react_1.default.createElement(tags_1.w.p, null,
            react_1.default.createElement(tags_1.w.pPr, null,
                react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent}` })),
            react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: TOCLabel.children, emphasis: true, docxOptions }))));
    }
    for (const child of el.children) {
        if (std.isTOCLabel(child)) {
            continue;
        }
        else if (std.isTOCItem(child)) {
            blocks.push(react_1.default.createElement(exports.DOCXTOCItem, { el: child, indent: indent + 1, docxOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(blocks)));
}));
exports.HTMLTOCItem = (0, html_1.wrapHTMLComponent)("HTMLTOCItem", ((props) => {
    const { el, htmlOptions, indent } = props;
    const blocks = [];
    const TOCItemTitle = el.children.find(c => std.isArticleGroupTitle(c) || std.isSupplProvisionLabel(c) || std.isArticleTitle(c));
    const ArticleRange = el.children.find(c => std.isArticleRange(c) || std.isArticleCaption(c));
    if (TOCItemTitle || ArticleRange) {
        blocks.push((react_1.default.createElement("div", { className: `toc-item-main indent-${indent}` },
            (TOCItemTitle !== undefined) && (react_1.default.createElement("span", { className: "toc-item-title", ...(0, html_1.elProps)(TOCItemTitle, htmlOptions) },
                react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: TOCItemTitle.children, htmlOptions }))),
            (ArticleRange !== undefined) && (react_1.default.createElement("span", { className: "article-range", ...(0, html_1.elProps)(ArticleRange, htmlOptions) },
                react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: ArticleRange.children, htmlOptions }))))));
    }
    for (let i = 0; i < el.children.length; i++) {
        const child = el.children[i];
        if (std.isArticleGroupTitle(child)
            || std.isSupplProvisionLabel(child)
            || std.isArticleRange(child)
            || std.isArticleTitle(child)
            || std.isArticleCaption(child)) {
            continue;
        }
        else if (std.isTOCItem(child)) {
            blocks.push(react_1.default.createElement(exports.HTMLTOCItem, { el: child, indent: indent + 1, htmlOptions }));
        }
        else if (typeof child === "string" || (0, inline_1.isSentenceChildEL)(child)) {
            // "Line", "QuoteStruct", "ArithFormula", "Ruby", "Sup", "Sub"
            let j = i + 1;
            while (j < el.children.length && (typeof el.children[j] === "string" || (0, inline_1.isSentenceChildEL)(el.children[j])))
                j++;
            const sentenceChildren = el.children.slice(i, j);
            blocks.push((react_1.default.createElement("div", { className: `toc-item-main indent-${indent}` },
                react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: sentenceChildren, htmlOptions }))));
            i = j - 1;
        }
        else {
            throw (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement("div", { className: `toc-item-${el.tag}`, ...(0, html_1.elProps)(el, htmlOptions) }, (0, common_1.withKey)(blocks)));
}));
exports.DOCXTOCItem = (0, component_1.wrapDOCXComponent)("DOCXTOCItem", ((props) => {
    const { el, docxOptions, indent } = props;
    const blocks = [];
    const TOCItemTitle = el.children.find(c => std.isArticleGroupTitle(c) || std.isSupplProvisionLabel(c) || std.isArticleTitle(c));
    const ArticleRange = el.children.find(c => std.isArticleRange(c) || std.isArticleCaption(c));
    if (TOCItemTitle || ArticleRange) {
        blocks.push((react_1.default.createElement(tags_1.w.p, null,
            react_1.default.createElement(tags_1.w.pPr, null,
                react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent}` })),
            (TOCItemTitle !== undefined) && react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: TOCItemTitle.children, docxOptions }),
            (ArticleRange !== undefined) && react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: ArticleRange.children, docxOptions }))));
    }
    for (let i = 0; i < el.children.length; i++) {
        const child = el.children[i];
        if (std.isArticleGroupTitle(child)
            || std.isSupplProvisionLabel(child)
            || std.isArticleRange(child)
            || std.isArticleTitle(child)
            || std.isArticleCaption(child)) {
            continue;
        }
        else if (std.isTOCItem(child)) {
            blocks.push(react_1.default.createElement(exports.DOCXTOCItem, { el: child, indent: indent + 1, docxOptions }));
        }
        else if (typeof child === "string" || (0, inline_1.isSentenceChildEL)(child)) {
            // "Line", "QuoteStruct", "ArithFormula", "Ruby", "Sup", "Sub"
            let j = i + 1;
            while (j < el.children.length && (typeof el.children[j] === "string" || (0, inline_1.isSentenceChildEL)(el.children[j])))
                j++;
            const sentenceChildren = el.children.slice(i, j);
            blocks.push((react_1.default.createElement(tags_1.w.p, null,
                react_1.default.createElement(tags_1.w.pPr, null,
                    react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent}` })),
                react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: sentenceChildren, docxOptions }))));
            i = j - 1;
        }
        else {
            throw (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(blocks)));
}));
//# sourceMappingURL=toc.js.map